export const inventoryOverviewLabels = {
    de: {
        title: 'Lagerübersicht',
        description: 'Aktuelle Bestände nach Artikel, Charge, Lager und Lagerplatz.',
        valuationHint: 'Operativer Bestandswert: Menge × Chargen-Einstandspreis, sonst Artikel-Einkaufspreis. Ein nicht hinterlegter Artikelpreis (0) gilt als fehlend. Werte bleiben je Währung getrennt; fehlende Preise sind nicht enthalten.',
        palletHint: 'Palettennummern stammen aus lesbaren Chargen-Zusatzfeldern (z. B. Palet No oder SSCC). Sie gelten für die Charge; die angezeigte Menge gilt je Lagerplatz und Charge, nicht je Palette.',
        reservationHint: 'Reserviert und verfügbar gelten für die gesamte Charge bzw. den gesamten Artikel über alle Lagerplätze. Diese Werte werden bei mehreren Lagerplätzen wiederholt und dürfen nicht addiert werden.',
        search: 'Artikel, Charge oder Palettennummer suchen',
        warehouse: 'Lager',
        bin: 'Lagerplatz',
        all: 'Alle',
        unknown: 'Nicht zugeordnet',
        state: 'Bestandsart',
        expiry: 'Restlaufzeit',
        missingCost: 'Nur fehlende Preise',
        unknownOnly: 'Nur unvollständige Lagerzuordnung',
        reset: 'Filter zurücksetzen',
        refresh: 'Aktualisieren',
        export: 'CSV exportieren',
        exportLimit: 'Der Export ist auf 10.000 Positionen begrenzt. Bitte Filter eingrenzen.',
        exportError: 'Der Export konnte nicht erstellt werden. Bitte erneut versuchen.',
        loadError: 'Die Lagerübersicht konnte nicht geladen werden.',
        retry: 'Erneut versuchen',
        empty: 'Keine Bestände für diese Auswahl.',
        emptyAction: 'Filter zurücksetzen oder Bestand über den Lagerimport erfassen.',
        positions: 'Bestandspositionen',
        products: 'Artikel',
        batches: 'Chargen',
        value: 'Bewerteter Bestand',
        unvalued: 'Positionen ohne Preis',
        unlocated: 'Positionen ohne vollständigen Lagerort',
        quantity: 'Bestand',
        articleNumber: 'Artikelnummer',
        product: 'Artikel',
        batch: 'Charge',
        pallet: 'Palettennummer (Charge)',
        status: 'Status',
        cost: 'Einstandspreis / Basiseinheit',
        costSource: 'Preisbasis',
        stockValue: 'Bestandswert',
        reserved: 'Reserviert (Charge/Artikel gesamt)',
        available: 'Verfügbar (Charge/Artikel gesamt)',
        bestBefore: 'MHD',
        expires: 'Verfallsdatum',
        currency: 'Währung',
        unit: 'Basiseinheit',
        page: 'Seite {{current}} von {{total}}',
        previous: 'Vorherige Seite',
        next: 'Nächste Seite',
        sort: 'Sortierung',
        sortArticle: 'Artikelnummer aufsteigend',
        sortValue: 'Bestandswert absteigend (je Währung)',
        sortQuantity: 'Bestand absteigend',
        sortExpiry: 'MHD aufsteigend',
        asOf: 'Stand: {{date}}',
        stockState_AVAILABLE: 'Regulärer Bestand',
        stockState_QUARANTINE: 'Quarantäne',
        costSource_BATCH: 'Chargen-Einstandspreis',
        costSource_PRODUCT: 'Artikel-Einkaufspreis',
        costSource_MISSING: 'Preis fehlt',
        expiry_OK: 'Unauffällig / ohne Datum',
        expiry_WARNING: 'Warnung',
        expiry_CRITICAL: 'Kritisch',
        expiry_EXPIRED: 'Abgelaufen',
        issue_UNKNOWN_LOCATION: 'Lagerzuordnung unvollständig',
        issue_MISSING_COST: 'Preis fehlt',
        issue_NEGATIVE_BALANCE: 'Negativer Zuordnungsbestand: prüfen',
        issue_STOCK_MISMATCH: 'Chargensumme weicht vom Artikelbestand ab: prüfen',
        batchStatus_FREE: 'Freigegeben',
        batchStatus_BLOCKED: 'Gesperrt',
        batchStatus_QUARANTINE: 'Quarantäne',
        batchStatus_EXPIRED: 'Abgelaufen',
        batchStatus_DEPLETED: 'Aufgebraucht',
        issues: 'Prüfhinweise',
        columns: 'Spalten',
        issue_UNRESOLVED_BATCH: 'Chargenbezug ungeklärt: prüfen',
    },
    en: {
        title: 'Warehouse overview',
        description: 'Current stock by product, batch, warehouse and storage location.',
        valuationHint: 'Operational stock value: quantity × batch unit cost, otherwise product purchase price. An unset product price (0) counts as missing. Values stay separate by currency; missing prices are excluded.',
        palletHint: 'Pallet numbers come from readable batch custom fields (e.g. Palet No or SSCC). They identify the batch; quantities refer to the storage location and batch, not an individual pallet.',
        reservationHint: 'Reserved and available quantities refer to the entire batch or product across all locations. They repeat across location rows and must not be added together.',
        search: 'Search products, batches or pallet numbers',
        warehouse: 'Warehouse',
        bin: 'Storage location',
        all: 'All',
        unknown: 'Unassigned',
        state: 'Stock type',
        expiry: 'Remaining shelf life',
        missingCost: 'Missing prices only',
        unknownOnly: 'Incomplete locations only',
        reset: 'Reset filters',
        refresh: 'Refresh',
        export: 'Export CSV',
        exportLimit: 'Exports are limited to 10,000 positions. Narrow the filters.',
        exportError: 'The export could not be created. Please try again.',
        loadError: 'The warehouse overview could not be loaded.',
        retry: 'Try again',
        empty: 'No stock matches this selection.',
        emptyAction: 'Reset the filters or record stock using the warehouse import.',
        positions: 'Stock positions',
        products: 'Products',
        batches: 'Batches',
        value: 'Valued stock',
        unvalued: 'Positions without a price',
        unlocated: 'Positions without a complete location',
        quantity: 'Stock',
        articleNumber: 'Article number',
        product: 'Product',
        batch: 'Batch',
        pallet: 'Pallet number (batch)',
        status: 'Status',
        cost: 'Unit cost / base unit',
        costSource: 'Cost basis',
        stockValue: 'Stock value',
        reserved: 'Reserved (whole batch/product)',
        available: 'Available (whole batch/product)',
        bestBefore: 'Best before',
        expires: 'Expiry date',
        currency: 'Currency',
        unit: 'Base unit',
        page: 'Page {{current}} of {{total}}',
        previous: 'Previous page',
        next: 'Next page',
        sort: 'Sort',
        sortArticle: 'Article number ascending',
        sortValue: 'Stock value descending (per currency)',
        sortQuantity: 'Stock descending',
        sortExpiry: 'Best-before date ascending',
        asOf: 'As of: {{date}}',
        stockState_AVAILABLE: 'Regular stock',
        stockState_QUARANTINE: 'Quarantine',
        costSource_BATCH: 'Batch unit cost',
        costSource_PRODUCT: 'Product purchase price',
        costSource_MISSING: 'Missing price',
        expiry_OK: 'OK / no date',
        expiry_WARNING: 'Warning',
        expiry_CRITICAL: 'Critical',
        expiry_EXPIRED: 'Expired',
        issue_UNKNOWN_LOCATION: 'Incomplete location',
        issue_MISSING_COST: 'Missing price',
        issue_NEGATIVE_BALANCE: 'Negative location balance: review',
        issue_STOCK_MISMATCH: 'Batch total differs from product stock: review',
        batchStatus_FREE: 'Released',
        batchStatus_BLOCKED: 'Blocked',
        batchStatus_QUARANTINE: 'Quarantine',
        batchStatus_EXPIRED: 'Expired',
        batchStatus_DEPLETED: 'Depleted',
        issues: 'Review notes',
        columns: 'Columns',
        issue_UNRESOLVED_BATCH: 'Unresolved batch reference: review',
    },
    fr: {
        title: 'Vue du stock',
        description: 'Stock actuel par article, lot, entrepôt et emplacement.',
        valuationHint: 'Valeur opérationnelle du stock : quantité × coût unitaire du lot, sinon prix d’achat de l’article. Un prix d’article non renseigné (0) est considéré comme manquant. Les devises restent séparées ; les prix manquants sont exclus.',
        palletHint: 'Les numéros de palette proviennent des champs de lot lisibles (p. ex. Palet No ou SSCC). Ils identifient le lot ; les quantités concernent l’emplacement et le lot, pas une palette individuelle.',
        reservationHint: 'Les quantités réservées et disponibles concernent le lot ou l’article entier, tous emplacements confondus. Elles se répètent par emplacement et ne doivent pas être additionnées.',
        search: 'Rechercher un article, lot ou numéro de palette',
        warehouse: 'Entrepôt',
        bin: 'Emplacement',
        all: 'Tous',
        unknown: 'Non affecté',
        state: 'Type de stock',
        expiry: 'Durée restante',
        missingCost: 'Prix manquants uniquement',
        unknownOnly: 'Emplacements incomplets uniquement',
        reset: 'Réinitialiser les filtres',
        refresh: 'Actualiser',
        export: 'Exporter CSV',
        exportLimit: 'L’export est limité à 10 000 positions. Réduisez la sélection.',
        exportError: 'L’export n’a pas pu être créé. Réessayez.',
        loadError: 'Impossible de charger la vue du stock.',
        retry: 'Réessayer',
        empty: 'Aucun stock pour cette sélection.',
        emptyAction: 'Réinitialisez les filtres ou enregistrez du stock avec l’import.',
        positions: 'Positions de stock',
        products: 'Articles',
        batches: 'Lots',
        value: 'Stock valorisé',
        unvalued: 'Positions sans prix',
        unlocated: 'Positions sans emplacement complet',
        quantity: 'Stock',
        articleNumber: 'Numéro d’article',
        product: 'Article',
        batch: 'Lot',
        pallet: 'Numéro de palette (lot)',
        status: 'Statut',
        cost: 'Coût unitaire / unité de base',
        costSource: 'Base du coût',
        stockValue: 'Valeur du stock',
        reserved: 'Réservé (lot/article entier)',
        available: 'Disponible (lot/article entier)',
        bestBefore: 'DDM',
        expires: 'Date de péremption',
        currency: 'Devise',
        unit: 'Unité de base',
        page: 'Page {{current}} sur {{total}}',
        previous: 'Page précédente',
        next: 'Page suivante',
        sort: 'Tri',
        sortArticle: 'Numéro d’article croissant',
        sortValue: 'Valeur décroissante (par devise)',
        sortQuantity: 'Stock décroissant',
        sortExpiry: 'DDM croissante',
        asOf: 'Au : {{date}}',
        stockState_AVAILABLE: 'Stock normal',
        stockState_QUARANTINE: 'Quarantaine',
        costSource_BATCH: 'Coût unitaire du lot',
        costSource_PRODUCT: 'Prix d’achat de l’article',
        costSource_MISSING: 'Prix manquant',
        expiry_OK: 'Normal / sans date',
        expiry_WARNING: 'Avertissement',
        expiry_CRITICAL: 'Critique',
        expiry_EXPIRED: 'Périmé',
        issue_UNKNOWN_LOCATION: 'Emplacement incomplet',
        issue_MISSING_COST: 'Prix manquant',
        issue_NEGATIVE_BALANCE: 'Solde d’emplacement négatif : vérifier',
        issue_STOCK_MISMATCH: 'Total des lots différent du stock article : vérifier',
        batchStatus_FREE: 'Libéré',
        batchStatus_BLOCKED: 'Bloqué',
        batchStatus_QUARANTINE: 'Quarantaine',
        batchStatus_EXPIRED: 'Périmé',
        batchStatus_DEPLETED: 'Épuisé',
        issues: 'Points à vérifier',
        columns: 'Colonnes',
        issue_UNRESOLVED_BATCH: 'Référence de lot non résolue : vérifier',
    },
    es: {
        title: 'Resumen de almacén',
        description: 'Existencias actuales por artículo, lote, almacén y ubicación.',
        valuationHint: 'Valor operativo: cantidad × coste unitario del lote o, en su defecto, precio de compra del artículo. Un precio de artículo sin registrar (0) se considera ausente. Las divisas se mantienen separadas; se excluyen los precios ausentes.',
        palletHint: 'Los números de palé proceden de campos de lote legibles (p. ej., Palet No o SSCC). Identifican el lote; las cantidades corresponden a la ubicación y al lote, no a un palé individual.',
        reservationHint: 'Las cantidades reservadas y disponibles corresponden al lote o artículo completo en todas las ubicaciones. Se repiten por ubicación y no deben sumarse.',
        search: 'Buscar artículos, lotes o números de palé',
        warehouse: 'Almacén',
        bin: 'Ubicación',
        all: 'Todos',
        unknown: 'Sin asignar',
        state: 'Tipo de existencias',
        expiry: 'Vida útil restante',
        missingCost: 'Solo precios ausentes',
        unknownOnly: 'Solo ubicaciones incompletas',
        reset: 'Restablecer filtros',
        refresh: 'Actualizar',
        export: 'Exportar CSV',
        exportLimit: 'La exportación está limitada a 10.000 posiciones. Reduzca los filtros.',
        exportError: 'No se pudo crear la exportación. Inténtelo de nuevo.',
        loadError: 'No se pudo cargar el resumen de almacén.',
        retry: 'Reintentar',
        empty: 'No hay existencias para esta selección.',
        emptyAction: 'Restablezca los filtros o registre existencias mediante la importación.',
        positions: 'Posiciones de existencias',
        products: 'Artículos',
        batches: 'Lotes',
        value: 'Existencias valoradas',
        unvalued: 'Posiciones sin precio',
        unlocated: 'Posiciones sin ubicación completa',
        quantity: 'Existencias',
        articleNumber: 'Número de artículo',
        product: 'Artículo',
        batch: 'Lote',
        pallet: 'Número de palé (lote)',
        status: 'Estado',
        cost: 'Coste unitario / unidad base',
        costSource: 'Base del coste',
        stockValue: 'Valor de existencias',
        reserved: 'Reservado (lote/artículo completo)',
        available: 'Disponible (lote/artículo completo)',
        bestBefore: 'Consumo preferente',
        expires: 'Fecha de caducidad',
        currency: 'Divisa',
        unit: 'Unidad base',
        page: 'Página {{current}} de {{total}}',
        previous: 'Página anterior',
        next: 'Página siguiente',
        sort: 'Orden',
        sortArticle: 'Número de artículo ascendente',
        sortValue: 'Valor descendente (por divisa)',
        sortQuantity: 'Existencias descendentes',
        sortExpiry: 'Consumo preferente ascendente',
        asOf: 'A fecha de: {{date}}',
        stockState_AVAILABLE: 'Existencias normales',
        stockState_QUARANTINE: 'Cuarentena',
        costSource_BATCH: 'Coste unitario del lote',
        costSource_PRODUCT: 'Precio de compra del artículo',
        costSource_MISSING: 'Precio ausente',
        expiry_OK: 'Normal / sin fecha',
        expiry_WARNING: 'Aviso',
        expiry_CRITICAL: 'Crítico',
        expiry_EXPIRED: 'Caducado',
        issue_UNKNOWN_LOCATION: 'Ubicación incompleta',
        issue_MISSING_COST: 'Precio ausente',
        issue_NEGATIVE_BALANCE: 'Saldo de ubicación negativo: revisar',
        issue_STOCK_MISMATCH: 'Total de lotes distinto del artículo: revisar',
        batchStatus_FREE: 'Liberado',
        batchStatus_BLOCKED: 'Bloqueado',
        batchStatus_QUARANTINE: 'Cuarentena',
        batchStatus_EXPIRED: 'Caducado',
        batchStatus_DEPLETED: 'Agotado',
        issues: 'Puntos de revisión',
        columns: 'Columnas',
        issue_UNRESOLVED_BATCH: 'Referencia de lote no resuelta: revisar',
    },
    tr: {
        title: 'Depo özeti',
        description: 'Ürün, parti, depo ve konuma göre güncel stoklar.',
        valuationHint: 'Operasyonel stok değeri: miktar × parti birim maliyeti, yoksa ürün alış fiyatı. Girilmemiş ürün fiyatı (0) eksik sayılır. Para birimleri ayrı tutulur; fiyatı eksik stoklar değere dahil edilmez.',
        palletHint: 'Palet numaraları okunabilir parti ek alanlarından gelir (ör. Palet No veya SSCC). Partiyi tanımlar; miktarlar tek bir palete değil, konuma ve partiye aittir.',
        reservationHint: 'Rezerve ve kullanılabilir miktarlar tüm konumlardaki parti veya ürünün tamamına aittir. Konum satırlarında tekrarlanır ve toplanmamalıdır.',
        search: 'Ürün, parti veya palet numarası ara',
        warehouse: 'Depo',
        bin: 'Depo konumu',
        all: 'Tümü',
        unknown: 'Atanmamış',
        state: 'Stok türü',
        expiry: 'Kalan raf ömrü',
        missingCost: 'Yalnızca eksik fiyatlar',
        unknownOnly: 'Yalnızca eksik konumlar',
        reset: 'Filtreleri sıfırla',
        refresh: 'Yenile',
        export: 'CSV dışa aktar',
        exportLimit: 'Dışa aktarma 10.000 stok konumuyla sınırlıdır. Filtreleri daraltın.',
        exportError: 'Dışa aktarma oluşturulamadı. Tekrar deneyin.',
        loadError: 'Depo özeti yüklenemedi.',
        retry: 'Tekrar dene',
        empty: 'Bu seçim için stok yok.',
        emptyAction: 'Filtreleri sıfırlayın veya depo içe aktarımıyla stok kaydedin.',
        positions: 'Stok konumları',
        products: 'Ürünler',
        batches: 'Partiler',
        value: 'Değerlenmiş stok',
        unvalued: 'Fiyatı olmayan konumlar',
        unlocated: 'Tam konumu olmayan stoklar',
        quantity: 'Stok',
        articleNumber: 'Ürün numarası',
        product: 'Ürün',
        batch: 'Parti',
        pallet: 'Palet numarası (parti)',
        status: 'Durum',
        cost: 'Birim maliyet / temel birim',
        costSource: 'Maliyet kaynağı',
        stockValue: 'Stok değeri',
        reserved: 'Rezerve (tüm parti/ürün)',
        available: 'Kullanılabilir (tüm parti/ürün)',
        bestBefore: 'Tavsiye edilen tüketim tarihi',
        expires: 'Son kullanma tarihi',
        currency: 'Para birimi',
        unit: 'Temel birim',
        page: 'Sayfa {{current}} / {{total}}',
        previous: 'Önceki sayfa',
        next: 'Sonraki sayfa',
        sort: 'Sıralama',
        sortArticle: 'Ürün numarası artan',
        sortValue: 'Stok değeri azalan (para birimi bazında)',
        sortQuantity: 'Stok azalan',
        sortExpiry: 'Tüketim tarihi artan',
        asOf: 'Güncelleme: {{date}}',
        stockState_AVAILABLE: 'Normal stok',
        stockState_QUARANTINE: 'Karantina',
        costSource_BATCH: 'Parti birim maliyeti',
        costSource_PRODUCT: 'Ürün alış fiyatı',
        costSource_MISSING: 'Eksik fiyat',
        expiry_OK: 'Normal / tarih yok',
        expiry_WARNING: 'Uyarı',
        expiry_CRITICAL: 'Kritik',
        expiry_EXPIRED: 'Süresi dolmuş',
        issue_UNKNOWN_LOCATION: 'Eksik depo konumu',
        issue_MISSING_COST: 'Eksik fiyat',
        issue_NEGATIVE_BALANCE: 'Negatif konum bakiyesi: kontrol edin',
        issue_STOCK_MISMATCH: 'Parti toplamı ürün stoğundan farklı: kontrol edin',
        batchStatus_FREE: 'Serbest',
        batchStatus_BLOCKED: 'Bloke',
        batchStatus_QUARANTINE: 'Karantina',
        batchStatus_EXPIRED: 'Süresi dolmuş',
        batchStatus_DEPLETED: 'Tükenmiş',
        issues: 'Kontrol notları',
        columns: 'Sütunlar',
        issue_UNRESOLVED_BATCH: 'Çözümlenemeyen parti referansı: kontrol edin',
    },
};
//# sourceMappingURL=inventory-overview.js.map